export default __webpack_public_path__ + "static/media/help-rav-inv-19.31fe8582.png";